export default {"src":"/_next/static/media/TravelFeed-logo-horizontal-color.21f756c4.svg","height":256,"width":1485,"blurWidth":0,"blurHeight":0};